export const FIELD_DEFAULT_VALUE = 'defaultValue';
export const FIELD_VALUES_FILTER = 'valuesFilter';
export const FIELD_IS_FILTER = 'isFilter';
export const FIELD_TYPE = 'type';
export const FIELD_DISPLAY_CONTROL_TYPE = 'displayControlType';
export const FIELD_TEMPLATE_ID = 'templateId';